import { Building, InitHandlerPayload, Theme } from '@hqo/hqo-miniapp-client-sdk';
import { useMiniappSdkEventHandler } from 'app/shared/hooks/use-miniapp-sdk';
import { User } from 'app/data/types/user';
import { useState } from 'react';

interface SdkData {
  sdkUser?: User | null;
  sdkBuilding?: Building | null;
  sdkTheme?: Theme | null;
  /**
   * Host commands the native shell advertises in its init handshake (e.g.
   * `openExternalLink`). Drives capability-gated behaviour — see
   * `useOpenExternalLink`. Only delivered via `initResponse`, and the SDK
   * doesn't replay that event, so read it where the handler is registered
   * before boot (i.e. at the app root, not in a late-mounted component).
   *
   * `null` until the first `initResponse` so callers can distinguish "unknown"
   * from "host advertised an empty list".
   */
  availableCmds: string[] | null;
}

export const useSdkData = (): SdkData => {
  const [sdkUser, setSdkUser] = useState<User | null>(null);
  const [sdkBuilding, setSdkBuilding] = useState<Building | null>(null);
  const [sdkTheme, setSdkTheme] = useState<Theme | null>(null);
  const [availableCmds, setAvailableCmds] = useState<string[] | null>(null);

  useMiniappSdkEventHandler(
    'initResponse',
    (eventData) => {
      const data = eventData as InitHandlerPayload;

      if (data?.user) {
        setSdkUser(data.user);
      }
      if (data?.building) {
        setSdkBuilding(data.building);
      }
      if (data?.theme) {
        setSdkTheme(data.theme);
      }
      setAvailableCmds(data?.available_cmds ?? []);
    },
    [],
  );

  return { sdkUser, sdkBuilding, sdkTheme, availableCmds };
};
